module.exports = __webpack_public_path__ + "graphql_devday.7c9b06f10316dbbad99d.png";